import Button from "@mui/material/Button";

interface GButtonProps {
  text: string;
  color?: string;
  icon?: React.ReactNode;
  type?: boolean;
  disabled?: boolean;
  backgroundColor?: string;
  width?: number;
  handleAction?: () => void;
}
function GButtonOutlined(props: GButtonProps) {
  return (
    <Button
      variant="outlined"
      disabled={props.disabled}
      sx={{
        borderRadius: 60,
        minWidth: props.width ? props.width : 234,
        fontSize: 18,
        borderColor: props.color,
        color: props.color,
      }}
      onClick={() => {
        props.handleAction && props.handleAction();
      }}
      endIcon={props.icon && props.icon}
      type={props.type ? "submit" : undefined}
    >
      {props.text}
    </Button>
  );
}

export default GButtonOutlined;
